// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8730) return "static/chunks/8730-c3c68f6e07e16b2a.js";
	if (chunkId === 2793) return "static/chunks/2793-7f1dc15d6e9808fb.js";
	if (chunkId === 2036) return "static/chunks/2036-76199fa5cb527f7c.js";
	if (chunkId === 7006) return "static/chunks/7006-99be8fa4b142d6b9.js";
	if (chunkId === 4911) return "static/chunks/4911-c67d4646c1199619.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"313":"c699510642ea7c55","838":"de580e3a94b56766","5198":"1cecd042c70335f6","6037":"b21ddeeda376fd41","7164":"2ba177ef4ed5ed78"}[chunkId] + ".js";
};